import comp from '../components/barrel';
import svg from '../js/svg';
import U from '../js/utils';

export default {
  async prepare() {
    // Remove API calls from here
    this.target_user_uuid = thsPage.vars.target_user_uuid;
  },

  async render() {
    // Make API calls here when the tab is actually accessed
    await this.loadData();
    
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadData() {
    // Clear any existing methods
    this.recipe.methods = [];
    
    this.target_user_uuid = thsPage.vars.target_user_uuid;
    const vars = {};
    vars.target_user_uuid = this.target_user_uuid;
    
    this.recipe.methods.push(await O.mPOST('navigation/get-navigation-list', vars));
    this.recipe.methods.push(await O.mPOST('navigation/get-allocNavUser-list', vars));
  },

  async loadPage(data) {
    this.navlist = data[`navigation/get-navigation-list`].data;
    this.allocNavlist = data[`navigation/get-allocNavUser-list`].data;

    const navCategories = [];

    // Create a Set to track unique nav_category values
    const navTypeSet = new Set();

    this.navlist.forEach((item) => {
      if (!navTypeSet.has(item.nav_category)) {
        navTypeSet.add(item.nav_category);
        navCategories.push({nav_category: item.nav_category});
      }
    });
    this.navCategories = navCategories;

    // Make functions globally accessible
    window.allocateNavigation = (nav_uuid) => this.allocateNavigation(nav_uuid);
    window.removeNavigation = (user_nav_uuid) => this.removeNavigation(user_nav_uuid);

    await this.buildPage();
  },

  async buildPage() {
    // ====================================
    // Nav List
    const navCategories = this.navCategories;

    const navListDiv = U.id('navListDiv');
    navListDiv.innerHTML = '';

    navCategories.forEach((category) => {
      const categoryDiv = U.divAtt('div', 'class', 'mb-6');
      const categoryHeading = U.divAtt('h6', 'class', 'mb-3');
      categoryHeading.innerHTML = category.nav_category;
      categoryDiv.appendChild(categoryHeading);

      const navItems = this.navlist.filter((item) => item.nav_category === category.nav_category);

      navItems.forEach((navItem) => {
        const navDiv = U.divAtt('div', 'class', 'flex items-center justify-between p-3 border rounded mb-2');
        
        const navInfo = U.divAtt('div', 'class', 'flex-1');
        const navName = U.divAtt('span', 'class', 'font-medium');
        navName.innerHTML = navItem.short_text;
        navInfo.appendChild(navName);

        const navDesc = U.divAtt('span', 'class', 'text-sm text-gray-600 ml-2');
        navDesc.innerHTML = navItem.long_text || '';
        navInfo.appendChild(navDesc);

        navDiv.appendChild(navInfo);

        // Add allocation button
        const allocButton = U.divAtt('button', 'class', 'px-3 py-1 bg-blue-500 text-white rounded text-sm');
        allocButton.innerHTML = 'Allocate';
        allocButton.setAttribute('onclick', `allocateNavigation('${navItem.navigation_uuid}')`);
        navDiv.appendChild(allocButton);

        categoryDiv.appendChild(navDiv);
      });

      navListDiv.appendChild(categoryDiv);
    });

    // ====================================
    // Allocated Nav List
    await this.buildAllocatedNavList();
  },

  async buildAllocatedNavList() {
    const allocNavListDiv = U.id('allocNavListDiv');
    allocNavListDiv.innerHTML = '';

    if (!this.allocNavlist || this.allocNavlist.length === 0) {
      const emptyDiv = U.divAtt('div', 'class', 'text-center py-8 text-gray-500');
      emptyDiv.innerHTML = 'No navigation items allocated to this user.';
      allocNavListDiv.appendChild(emptyDiv);
      return;
    }

    const heading = U.divAtt('h6', 'class', 'mb-3 mt-8');
    heading.innerHTML = 'Allocated Navigation Items';
    allocNavListDiv.appendChild(heading);

    this.allocNavlist.forEach((allocNav) => {
      const navDiv = U.divAtt('div', 'class', 'flex items-center justify-between p-3 border rounded mb-2 bg-green-50');
      
      const navInfo = U.divAtt('div', 'class', 'flex-1');
      const navName = U.divAtt('span', 'class', 'font-medium');
      const category = allocNav.nav_category || '';
      const shortText = allocNav.short_text || '';
      const longText = allocNav.long_text || '';
      navName.innerHTML = category ? `${category}: ${shortText} - ${longText}` : `${shortText} - ${longText}`;
      navInfo.appendChild(navName);

      navDiv.appendChild(navInfo);

      // Add remove button
      const removeButton = U.divAtt('button', 'class', 'px-3 py-1 bg-red-500 text-white rounded text-sm');
      removeButton.innerHTML = 'Remove';
      removeButton.setAttribute('onclick', `removeNavigation('${allocNav.user_navigation_uuid}')`);
      navDiv.appendChild(removeButton);

      allocNavListDiv.appendChild(navDiv);
    });
  },

  async allocateNavigation(navigation_uuid) {
    const vars = {};
    vars.navigation_uuid = navigation_uuid;
    vars.target_user_uuid = this.target_user_uuid;

    try {
      const res = await O.PREP([await O.mPOST('navigation/ins-nav-user', vars)]);
      const msg = res['navigation/ins-nav-user'].status;
      comp.toast(msg);
      
      // Refresh the page to show updated allocations
      await this.render();
    } catch (error) {
      comp.toast('Error allocating navigation item');
    }
  },

  async removeNavigation(user_navigation_uuid) {
    const vars = {};
    vars.user_navigation_uuid = user_navigation_uuid;

    try {
      const res = await O.PREP([await O.mPOST('navigation/rmv-nav-user', vars)]);
      const msg = res['navigation/rmv-nav-user'].status;
      comp.toast(msg);
      
      // Refresh the page to show updated allocations
      await this.render();
    } catch (error) {
      comp.toast('Error removing navigation item');
    }
  },
};
